import Vue from "vue";

const success = (response, context) => {
  context.rental = response.data.rental;
  context.vrboAmenities = response.data.vrboAmenities;

  if (response.data.webSiteDefaultContent) {
    context.webSiteDefaultContent = response.data.webSiteDefaultContent;
  }
  context.user = response.data.user;
  if (response.data.user.vrbo_account) {
    context.vrbo.vrbo_account_active = response.data.user.vrbo_account.active;
  }
  context.membersForChecking = response.data.members;
  context.membersForCheckout = response.data.members;
  context.theKeys = response.data.thekeys_locks;
  context.igloohomeLocks = response.data.igloohomeLocks;
  context.nukiLocks = response.data.nukiLocks;
  context.isSmsSubscriptionActive = response.data.isSmsSubscriptionActive;
  if (context.serviceData) {
    context.serviceData.price_lab_email = response.data.rental.price_lab_email;
    context.serviceData.price_lab_api_key = response.data.rental.price_lab_api_key;
    context.serviceData.price_lab_enabled =
      response.data.rental.price_lab_enabled;
  }
  if (context.rental.city_taxes) {
    context.rental.city_taxes = context.rental.city_taxes.toFixed(2);
  }

  if (context.user.super_checkin_account) {
    context.superCheckinAccount = context.user.super_checkin_account;
    context.superCheckinLocks = context.superCheckinAccount.super_checkin_locks;
  }

  if (context.theKeys) {
    context.theKeys.map((lock) => {
      const checkinStartTime = lock.arrival_time.split(":");
      const checkinEndTime = lock.departure_time.split(":");
      lock.timeIn = {
        HH: checkinStartTime[0],
        mm: checkinStartTime[1],
      };
      lock.timeOut = {
        HH: checkinEndTime[0],
        mm: checkinEndTime[1],
      };
    });
  }

  if (context.lock_types) {
    context.lock_types = response.data.lock_types;
  }

  if (context.rental.contract) {
    context.contract = context.rental.contract.content;
  } else {
    context.contract = context.templates[0].content;
  }

  if (context.rental.invoice_template) {
    context.rental.invoice_template = context.rental.invoice_template.content;
  } else {
    context.rental.invoice_template = context.templates[0].content;
  }

  if (context.rental.refund_days == "" || context.rental.refund_days == null) {
    context.rental.refund_days = 0;
  }
  if (context.rental.lock_type) {
    context.lockType = context.rental.lock_type;
    if (context.rental.lock_type === "SuperCheckin") {
      context.getSuperCheckinLocks(context.rental.id);
    } else if (context.rental.lock_type === "TheKeys") {
      context.isTheKeysSelected = true;
    } else if (context.rental.lock_type === "Igloohome") {
      context.isIgloohomeSelected = true;
    } else if (context.rental.lock_type === "Nuki") {
      context.isNukiLockSelected = true;
    }
  }

  if (context.rental.auto_confirm_platform_id) {
    context.selectedPlatforms = JSON.parse(
      context.rental.auto_confirm_platform_id
    );
  }

  if (context.rental.deposit_auto_confirm_platform_ids) {
    context.selectedDepositPlatforms = JSON.parse(
      context.rental.deposit_auto_confirm_platform_ids
    );
  }

  context.rentalBookingComConfigs.rateCode =
    context.rentalBookingComConfigs.rateCode && context.rental.booking_rate_id;
  context.rentalBookingComConfigs.roomCode =
    context.rentalBookingComConfigs.roomCode && context.rental.booking_room_id;
  context.rentalBookingComConfigs.hotelId =
    context.rentalBookingComConfigs.hotelId && context.rental.booking_hotel_id;

  if (
    ((context.user.plan_id === 4 && !context.user.is_team_member) ||
      (context.user.is_team_member &&
        context.rental.userPlanId &&
        context.rental.userPlanId === 4)) &&
    response.data.roomCodes
  ) {
    context.roomCodes = response.data.roomCodes;
  }

  if (
    ((context.user.plan_id === 4 && !context.user.is_team_member) ||
      (context.user.is_team_member &&
        context.rental.userPlanId &&
        context.rental.userPlanId === 4)) &&
    response.data.rateCodes
  ) {
    context.rateCodes = response.data.rateCodes;
  }

  context.priceMultiplier = response.data.priceMultiplier;
};

const failed = (error, context) => {
  context.loading = false;
  toastr.error(error);
  Vue.router.push({
    name: "rentals.index",
  });
};

export default (id, context) =>
  Vue.$http
    .get(`/rentals/${id}`)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      } else {
        failed();
      }
    })
    .catch((error) => {
      failed(error, context);
    });



// WEBPACK FOOTER //
// ./src/app/services/rental/getById.js